import Vue from "vue";
import VueI18n from "vue-i18n";
import zhCN from "./locales/zh-CN";
import enUS from "./locales/en-US";

Vue.use(VueI18n);

const LOCALE_KEY = "locale";
const DEFAULT_LOCALE = "en-US";

function getSavedLocale() {
  const saved = localStorage.getItem(LOCALE_KEY);
  return saved === "en-US" || saved === "zh-CN" ? saved : DEFAULT_LOCALE;
}

const i18n = new VueI18n({
  locale: getSavedLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    "zh-CN": zhCN,
    "en-US": enUS,
  },
});

export function setPageLocale(locale) {
  i18n.locale = locale;
  localStorage.setItem(LOCALE_KEY, locale);
  document.documentElement.lang = locale === "en-US" ? "en" : "zh-CN";
  document.title = i18n.t("site.title");
}

export function toggleLocale() {
  const next = i18n.locale === "zh-CN" ? "en-US" : "zh-CN";
  setPageLocale(next);
  return next;
}

setPageLocale(i18n.locale);

export default i18n;
